export const FIND_RESULT_SUCCESS = 'FIND_RESULT_SUCCESS';

export const findResultSuccess = result => ({
    type: FIND_RESULT_SUCCESS,
    payload: { result },
});
